export function capitalize(text) {
    const word = text.split(' ');
    const wordCapitalize = word.map(palavra => {
        if (palavra.length === 0) {
            return '';
        }

        return palavra[0].toUpperCase() + palavra.slice(1).toLowerCase();
    });

    return wordCapitalize.join(' ');
}

export function maskPhone(phone) {
  let textActual = phone.replace(/\D/g, ''); 
  let textFormatted = '';

  if (textActual.length > 10) { 
    textFormatted = `(${textActual.slice(0, 2)}) ${textActual.slice(2, 7)}-${textActual.slice(7)}`;
  } else if (textActual.length > 5) { 
    textFormatted = `(${textActual.slice(0, 2)}) ${textActual.slice(2, 6)}-${textActual.slice(6)}`;
  } else {
    textFormatted = `(${textActual.slice(0, 2)}) ${textActual.slice(2)}`;
  }
  
  return textFormatted; 
}